<template>
  <header 
    class="header" 
    :class="{
      'header-with-carousel': hasCarousel,
      'header-scroll': hasCarousel && isScrolled,
      'header--zh': $i18n.locale === 'zh'
    }"
  >
    <div class="header__container">
      <div class="header__logo">
        <a href="/" @click.prevent="handleLogoClick" ><img src="@/assets/home/logo@.png" alt="Logo" /></a>
      </div>
      
      <nav class="header__nav">
        <ul class="nav__list">
          <li class="nav__item">
            <router-link 
              to="/" 
              class="nav__link"
              :class="{ 'active-link': isHomePage }"
              exact
            >
              {{ $t('nav.home') }}
            </router-link>
          </li>
          
          <!-- 集团概括 -->
          <li class="nav__item has-dropdown">
            <router-link to="/group" class="nav__link">{{ $t('nav.group.title') }}</router-link>
            <ul class="dropdown-menu">
              <li>
                <router-link 
                  to="/group" 
                  class="nav__link1"
                  @click.native="scrollToSection('intro')"
                >
                  {{ $t('nav.group.intro') }}
                </router-link>
              </li>
              <li>
                <router-link 
                  to="/group" 
                  class="nav__link1"
                  @click.native="scrollToSection('members')"
                >
                  {{ $t('nav.group.members') }}
                </router-link>
              </li>
              <li>
                <router-link 
                  to="/group" 
                  class="nav__link1"
                  @click.native="scrollToSection('culture')"
                >
                  {{ $t('nav.group.culture') }}
                </router-link>
              </li>
              <li>
                <router-link 
                  to="/group" 
                  class="nav__link1"
                  @click.native="scrollToSection('products')"
                >
                  {{ $t('nav.group.products') }}
                </router-link>
              </li>
              <li>
                <router-link 
                  to="/group" 
                  class="nav__link1"
                  @click.native="scrollToSection('history')"
                >
                  {{ $t('nav.group.history') }}
                </router-link>
              </li>
              <li>
                <router-link 
                  to="/group" 
                  class="nav__link1"
                  @click.native="scrollToSection('honors')"
                >
                  {{ $t('nav.group.honors') }}
                </router-link>
              </li>
              <li>
                <router-link 
                  to="/group" 
                  class="nav__link1"
                  @click.native="scrollToSection('partners')"
                >
                  {{ $t('nav.group.partners') }}
                </router-link>
              </li>
              <li>
                <router-link 
                  to="/group" 
                  class="nav__link1"
                  @click.native="scrollToSection('contact')"
                >
                  {{ $t('nav.group.contact') }}
                </router-link>
              </li>
              <li>
                <router-link 
                  to="/group" 
                  class="nav__link1"
                  @click.native="scrollToSection('join')"
                >
                  {{ $t('nav.group.join') }}
                </router-link>
              </li>
            </ul>
          </li>
          
          <!-- 人才服务 -->
          <li class="nav__item has-dropdown">
            <router-link to="/talent" class="nav__link">{{ $t('nav.talent.title') }}</router-link>
            <ul class="dropdown-menu">
              <li><router-link to="/talent">{{ $t('nav.talent.lifecycle') }}</router-link></li>
              <li><router-link to="/talent/plan">{{ $t('nav.talent.plan') }}</router-link></li>
              <li><router-link to="/talent/policy">{{ $t('nav.talent.policy') }}</router-link></li>
              <li><router-link to="/talent/recruitment">{{ $t('nav.talent.recruitment') }}</router-link></li>
              <li><router-link to="/talent/recommend">{{ $t('nav.talent.recommendation') }}</router-link></li>
            </ul>
          </li>
          
          <!-- 企业服务 -->
          <li class="nav__item has-dropdown">
            <router-link to="/enterprise/lifecycle" class="nav__link">{{ $t('nav.enterprise.title') }}</router-link>
            <ul class="dropdown-menu">
              <li><router-link to="/enterprise/lifecycle">{{ $t('nav.enterprise.lifecycle') }}</router-link></li>
              <li><router-link to="/enterprise/policy">{{ $t('nav.enterprise.policy') }}</router-link></li>
            </ul>
          </li>
          
          <!-- 政府服务 -->
          <li class="nav__item has-dropdown">
            <router-link to="/government/service" class="nav__link">{{ $t('nav.government.title') }}</router-link>
            <ul class="dropdown-menu">
              <li><router-link to="/government/service">{{ $t('nav.government.service') }}</router-link></li>
              <li><router-link to="/government/cooperation">{{ $t('nav.government.cooperation') }}</router-link></li>
              <li><router-link to="/government/innovation">{{ $t('nav.government.innovation') }}</router-link></li>
            </ul>
          </li>
          
          <li class="nav__item">
            <router-link to="/activity" class="nav__link">{{ $t('nav.activities') }}</router-link>
          </li>
          <li class="nav__item">
            <router-link to="/news" class="nav__link">{{ $t('nav.news') }}</router-link>
          </li>
          <li class="nav__item">
            <router-link to="/courses" class="nav__link">{{ $t('nav.courses') }}</router-link>
          </li>
          
          <!-- 人才专家库 -->
          <li class="nav__item has-dropdown">
            <router-link to="/expert" class="nav__link">{{ $t('nav.experts.title') }}</router-link>
            <ul class="dropdown-menu">
              <li><router-link to="/expert">{{ $t('nav.experts.database') }}</router-link></li>
              <li><router-link to="/expert/interviews">{{ $t('nav.experts.interviews') }}</router-link></li>
            </ul>
          </li>

          <li class="nav__item">
            <router-link to="/apply" class="nav__link">{{ $t('nav.apply') }}</router-link>
          </li>
        </ul>
      </nav>

      <div class="header__right">
        <div class="search-box">
          <input 
            type="text" 
            :placeholder="$t('nav.searchPlaceholder')"
            v-model="searchKeyword"
            @keyup.enter="handleSearch"
          >
          <button class="search-btn" @click="handleSearch">
            <i class="fas fa-search"></i>
          </button>
        </div>
        
        <!-- 登录/注册按钮 -->
        <div class="auth-buttons" v-if="!haslogin">
          <div class="auth-btn" @click="Login">{{ $t('nav.login') }}</div>
          <span>/</span>
          <div class="auth-btn" @click="register">{{ $t('nav.register') }}</div>
        </div>

        <!-- 个人中心按钮 -->
        <div v-if="haslogin" class="auth-buttons">
          <div class="auth-btn" @click="goToUserCenter">{{ $t('nav.userCenter') }}{{ $t('nav.userCenter1') }}</div>
          <span>/</span>
          <div class="auth-btn" @click="handleLogout">{{ $t('nav.logout') }}</div>
          <!-- <span>/</span> -->
          <!-- <div class="auth-btn" @click="handleLogout">退出</div> -->
        </div>

        <button class="lang-switch" @click="toggleLanguage">
          {{ $t('nav.language') }}
        </button>
      </div>
    </div>

    <!-- 其他内容 -->

    <!-- 登录注册模态框 -->
    <el-dialog :visible.sync="visible" width="480px"  :modal-append-to-body="false">
      <div v-if="isLogin">
          <div style="
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 59px;
          width: 300px;
          margin: 0 auto;">
            <div v-if="!isDynamicLogin"
            @click="fastlogin(1)"
             style="
            width: 106px;
            height: 33px;
            font-weight: 500;
            font-size: 24px;
            color: rgba(0,0,0,0.85);
            line-height: 33px;
            text-align: center;
            font-style: normal;
            cursor: pointer;
            position: relative;">
            <div style="
            width: 80px;
            height: 2px;
            background: #3379F2;
            position: absolute;
            top: 140%;
            left: 50%;
            cursor: pointer;
            transform: translate(-50%, -50%);
            ">
            </div>
            {{ $t('nav.login1.passdeng') }}
            </div>
            <div v-if="isDynamicLogin" 
            @click="fastlogin(2)"
             style="
            width: 106px;
              height: 33px;
              font-weight: 400;
              font-size: 24px;
              color: #9B9B9B;
              line-height: 33px;
              text-align: center;
              font-style: normal;
              cursor: pointer;
              ">
                 {{ $t('nav.login1.passdeng') }}</div>
            <div  style="
            width: 1px;
            height: 59px;
            border: 1px solid #F0F0F0;"></div>
            <div v-if="isDynamicLogin" 
            @click="fastlogin(3)"
             style="
                width: 106px;
            height: 33px;
            font-weight: 500;
            font-size: 24px;
            color: rgba(0,0,0,0.85);
            line-height: 33px;
            text-align: center;
            font-style: normal;
            position: relative;
            cursor: pointer;
              "> <div  style="
              width: 80px;
              height: 2px;
              background: #3379F2;
              position: absolute;
              top: 140%;
              left: 50%;
              transform: translate(-50%, -50%);
            ">
            </div>
            {{ $t('nav.login1.dongtaideng') }}
              </div>
              <div v-if="!isDynamicLogin" 
              @click="fastlogin(4)"
               style="
              width: 106px;
              height: 33px;
              font-weight: 400;
              font-size: 24px;
              color: #9B9B9B;
              line-height: 33px;
              text-align: center;
              font-style: normal;
              cursor: pointer;
              ">
             
             {{ $t('nav.login1.dongtaideng') }}
              </div>
          </div>
          <div style="margin-top: 40px;">
          <div><el-input  v-model="loginForm.phone"  :placeholder="$t('nav.login1.phone')"
          style="margin-left: 0px;
          width: 368px;
          height: 40px;
          
          "
          ></el-input>
          </div>
          <div>
            <el-input v-if="!isDynamicLogin" v-model="loginForm.password" :placeholder="$t('nav.login1.password')"
          type="password"
          style="margin-top: 30px;
          margin-left: 0px;
          width: 368px;
          height: 40px;
          
          "
          
          ></el-input>
          <el-input v-if="isDynamicLogin" v-model="loginForm.code" :placeholder="$t('nav.login1.yanzhengma')"
        
          style="margin-top: 30px;
          margin-left: 0px;
          width: 248px;
          height: 40px;
          
          "
          ></el-input>
          <el-button v-if="isDynamicLogin" style="
          height: 40px;
          background: #3379F2;
          border-radius: 2px;
          margin-left: 10px;
          color: #FFFFFF;
          "
          @click="sendcode1()" :disabled="send==2" >{{send==1 ? $t('nav.login1.getyanzhengma') : `${minute}${$t('nav.login1.chongshi')}` }}</el-button>
          </div>
          
          <div style="margin-top: 30px;">
            <div style="width: 270px;
                height: 22px;
                font-weight: 400;
                font-size: 14px;
                color: #3379F2;
                line-height: 22px;
                text-align: right;
                font-style: normal;
                margin-left: 142px;
                cursor: pointer;
            ;" @click="Forgotpassword()">{{ $t('nav.login1.forgetpassword') }}?</div>
          </div>

          </div>
          <!-- <div style="width: 210px;
              height: 22px;
              font-weight: 400;
              font-size: 14px;
              color: #F2242E;
              line-height: 22px;
              text-align: left;
              font-style: normal;
              margin-left: 38px;
          ">{{errormsg}}</div> -->

          <div style="margin-top: 30px;" @click="loginlogin()">
            <el-button type="primary" style="
            width: 370px;
            height: 40px;
            background: #3379F2;
            border-radius: 2px;
            " >{{ $t('nav.login1.login') }}</el-button>
          </div>

          <div @click="register()" style="
            height: 22px;
            font-weight: 400;
            font-size: 14px;
            color: #3379F2;
            line-height: 22px;
            text-align: center;
            font-style: normal;
            margin-top: 30px;
            cursor: pointer;
          ">{{ $t('nav.login1.meizhanghao') }}</div>

      </div>
      <div v-if="reg">
        <div style="
          width: 96px;
          height: 33px;
          font-weight: 500;
          font-size: 24px;
          color: #000000;
          line-height: 33px;
          text-align: right;
          font-style: normal;
          margin-left: 170px;
          margin-top: -20px;
         ;">{{ $t('nav.login1.zhuce') }}</div>

         <div style="margin-top: 10px;margin-left: 35px;">
          <div>
            <div style="
            width: 80px;
            height: 20px;
            font-weight: 400;
            font-size: 14px;
            color: #303030;
            line-height: 20px;
            text-align: left;
            font-style: normal;
            margin-top: 10px;
            ">{{ $t('nav.login1.nick') }}</div>
            <el-input style="
            width: 370px;
            height: 45px;
            background: #FFFFFF;
            border-radius: 4px;
            margin-top: 10px;
            margin-left: -35px;
            ;" v-model="registerForm.username" :placeholder="$t('nav.login1.shurunick')"></el-input>
          </div>
          <div>
            <div 
            style="
            width: 128px;
            height: 20px;
            font-weight: 400;
            font-size: 14px;
            color: #303030;
            line-height: 20px;
            text-align: left;
            font-style: normal;
            margin-top: 10px;
            ">{{ $t('nav.login1.formphone') }}</div>
            <el-input style="
            width: 370px;
            height: 45px;
            background: #FFFFFF;
            border-radius: 4px;
            margin-top: 10px;
            margin-left: -35px;
            ;" v-model="registerForm.phone" :placeholder="$t('nav.login1.phone')"></el-input>
          </div>
          <div>
            <div style="
            width: 128px;
            height: 20px;
            font-weight: 400;
            font-size: 14px;
            color: #303030;
            line-height: 20px;
            text-align: left;
            font-style: normal;
            margin-top: 10px;
            ">{{ $t('nav.login1.yzm') }}</div>
            <div style="display: flex;">
              <el-input  style="
             width: 253px;
            height: 45px;
            margin-top: 10px;
            ;" v-model="registerForm.code" :placeholder="$t('nav.login1.yanzhengma')"></el-input>
            <el-button style="
            width: 108px;
            height: 40px;
            background: #3379F2;
            margin-left: 10px;
            margin-top: 10px;
            color: #FFFFFF;
            "
            @click="sendcode()" :disabled="send==2" >{{send==1 ? $t('nav.login1.getyanzhengma') : `${minute}${$t('nav.login1.chongshi')}` }}</el-button>
            </div>
          </div>
          <div>
            <div style="
            width: 128px;
            height: 20px;
            font-weight: 400;
            font-size: 14px;
            color: #303030;
            line-height: 20px;
            text-align: left;
            font-style: normal;
            margin-top: 10px;
            ">{{ $t('nav.login1.formpassword') }}</div>
            <el-input type="password" style="
            width: 370px;
            height: 45px;
            background: #FFFFFF;
            border-radius: 4px;
            margin-top: 10px;
            margin-left: -35px;
            ;" v-model="registerForm.password" :placeholder="$t('nav.login1.password')"></el-input>
          </div>
          <div>
            <div style="
            width: 128px;
            height: 20px;
            font-weight: 400;
            font-size: 14px;
            color: #303030;
            line-height: 20px;
            text-align: left;
            font-style: normal;
            margin-top: 10px;
            ">{{ $t('nav.login1.querenpassword') }}</div>
            <el-input type="password" style="
            width: 370px;
            height: 45px;
            background: #FFFFFF;
            border-radius: 4px;
            margin-top: 10px;
            margin-left: -35px;
            ;" v-model="registerForm.passagain" :placeholder="$t('nav.login1.formquerenpassword')"></el-input>
          </div>
          <div style="width: 210px;
              height: 22px;
              font-weight: 400;
              font-size: 14px;
              color: #F2242E;
              line-height: 22px;
              text-align: left;
              font-style: normal;
              margin-top: 22px;
          "></div>

          <div style="margin-left: -36px;margin-top: 10px;" @click="sendUserInfo()">
            <el-button type="primary" style="
            width: 370px;
            height: 40px;
            background: #3379F2;
            border-radius: 2px;
            " >{{ $t('nav.login1.zhuce1') }}</el-button>
          </div>

          <div @click="Login()" style="
            height: 22px;
            font-weight: 400;
            font-size: 14px;
            color: #3379F2;
            line-height: 22px;
            text-align: center;
            font-style: normal;
            cursor: pointer;
            margin-top: 30px;
            margin-left: -36px;
          ">{{ $t('nav.login1.youzhanghao') }}</div>
         </div>



      </div>
      <div v-if="Forgot">
        <div style="
          height: 33px;
          font-weight: 500;
          font-size: 24px;
          color: #000000;
          line-height: 33px;
          text-align: center;
          font-style: normal;
          margin-top: -20px;
          /* margin: 0 auto 0 auto */
         ;">{{ $t('nav.login1.forgetpassword') }}</div>

         <div style="margin-top: 10px;margin-left: 35px;">
        
          <div>
            <div 
            style="
            width: 128px;
            height: 20px;
            font-weight: 400;
            font-size: 14px;
            color: #303030;
            line-height: 20px;
            text-align: left;
            font-style: normal;
            margin-top: 10px;
            ">{{ $t('nav.login1.formphone') }}</div>
            <el-input  style="
            width: 370px;
            height: 45px;
            background: #FFFFFF;
            border-radius: 4px;
            margin-top: 10px;
            margin-left: -35px;
            ;" v-model="forgotPasswordForm.phone" :placeholder="$t('nav.login1.phone')"></el-input>
          </div>
          <div>
            <div style="
            width: 128px;
            height: 20px;
            font-weight: 400;
            font-size: 14px;
            color: #303030;
            line-height: 20px;
            text-align: left;
            font-style: normal;
            margin-top: 10px;
            ">{{ $t('nav.login1.yzm') }}</div>
            <div style="display: flex;">
              <el-input  style="
             width: 253px;
            height: 45px;
            margin-top: 10px;
            ;" v-model="forgotPasswordForm.code" :placeholder="$t('nav.login1.yanzhengma')"></el-input>
            <el-button style="
            width: 108px;
            height: 40px;
            background: #3379F2;
            margin-left: 10px;
            margin-top: 10px;
            color: #FFFFFF;
            "
            @click="sendcode2()" :disabled="send==2" >{{send==1 ? $t('nav.login1.getyanzhengma') : `${minute}${$t('nav.login1.chongshi')}` }}</el-button>
            </div>
          </div>
          <div>
            <div style="
            width: 128px;
            height: 20px;
            font-weight: 400;
            font-size: 14px;
            color: #303030;
            line-height: 20px;
            text-align: left;
            font-style: normal;
            margin-top: 10px;
            ">{{ $t('nav.login1.formpassword') }}</div>
            <el-input type="password" style="
            width: 370px;
            height: 45px;
            background: #FFFFFF;
            border-radius: 4px;
            margin-top: 10px;
            margin-left: -35px;
            ;" v-model="forgotPasswordForm.password" :placeholder="$t('nav.login1.password')"></el-input>
          </div>
          <div>
            <div style="
            width: 128px;
            height: 20px;
            font-weight: 400;
            font-size: 14px;
            color: #303030;
            line-height: 20px;
            text-align: left;
            font-style: normal;
            margin-top: 10px;
            ">{{ $t('nav.login1.querenpassword') }}</div>
            <el-input type="password" style="
            width: 370px;
            height: 45px;
            background: #FFFFFF;
            border-radius: 4px;
            margin-top: 10px;
            margin-left: -35px;
            ;" v-model="forgotPasswordForm.passagain" :placeholder="$t('nav.login1.formquerenpassword')"></el-input>
          </div>
          <div style="width: 210px;
              height: 22px;
              font-weight: 400;
              font-size: 14px;
              color: #F2242E;
              line-height: 22px;
              text-align: left;
              font-style: normal;
              margin-top: 22px;
          "></div>

          <div style="margin-left: -36px;margin-top: 10px;" @click="resetPassword()">
            <el-button type="primary" style="
            width: 370px;
            height: 40px;
            background: #3379F2;
            border-radius: 2px;
            " >{{ $t('nav.login1.chongzhimima') }}</el-button>
          </div>

      
         </div>



      </div>

    </el-dialog>
  </header>
 
</template>

<script>
import { sendUserInfo, SendCode, login, phoneLogin, resetPassword } from '@/api/user'
import backgroundImage from '@/assets/home/WechatIMG2523.jpg';


export default {
  name: 'SiteHeader',
  props: {
    isTransparent: {
      type: Boolean,
      default: false
    }
    
  },
  data() {
    // 添加手机号验证规则
    const validatePhone = (rule, value, callback) => {
      const phoneReg = /^1[3-9]\d{9}$/
      if (!value) {
        callback(new Error('请输入手机号'))
      } else if (!phoneReg.test(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }

    return {
      haslogin: localStorage.getItem('token') ? true : false,
      send:1,
      minute:60,
      currentLang: 'zh',
      searchKeyword: '',
      opacity: 0,
       visible: false,
      isLogin: true,
      isDynamicLogin: false,
      reg: false,
      Forgot: false,
      loginForm: {
        phone: '',
        password: ''
      },
      dynamicLoginForm: {
        phone: '',
        code: ''
      },
      registerForm: {
        username: '',
        phone: '',
        code: '',
        password: '',
        passagain: ''
      },
      forgotPasswordForm: {
        phone: '',
        code: '',
        password: '',
        passagain: ''
      },
      // 添加表单验证规则
      registerRules: {
        username: [
          { required: true, message: '请输入昵称', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        passagain: [
          { required: true, message: '请再次输入密码', trigger: 'blur' }
        ]
      },

      forgotPasswordRules: {
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
        passagain: [
          { required: true, message: '请再次输入密码', trigger: 'blur' }
        ]
      },
      hasCarousel: false,
      isScrolled: false,
   
    
    }
  },
  created() {
    // 在组件创建时检查登录状态
    this.checkLoginStatus()
    // this.toggleLanguage()
      // 从 localStorage 中读取用户语言偏好
  const savedLanguage = localStorage.getItem('userLanguage');
  if (savedLanguage) {
    this.$i18n.locale = savedLanguage; // 设置用户保存的语言
  }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleLogoClick() {
      // 获取当前语言
      const lang = this.$i18n.locale;

      // 手动跳转并传递语言参数
      this.$router.push({
        path: '/',
        query: { lang }
      });
    },

    checkLoginStatus() {
      // 检查 localStorage 中是否有 token
      const token = localStorage.getItem('token')
      this.haslogin = !!token // 将 token 存在与否转换为布尔值
      console.log('this.haslogin',this.haslogin)
      console.log('token',token)
    },
    
    async loginlogin() {
      try {
        let res
        if (this.isDynamicLogin) {
          res = await phoneLogin(this.loginForm)
        } else {
          res = await login(this.loginForm)
        }
        
        if (res.code === 1) {
          // 存储 token 和用户数据，确保转换为字符串

            localStorage.setItem('token', res.data.token)
            localStorage.setItem('user', JSON.stringify(res.data)) // 将对象转换为字符串存储
          


          // 获取收藏信息
          // let res1 = await getmypolicycollection({
          //   // id:res.data.id,
          //   // type:1
          // }, {
          //   headers: {
          //     'token': res.data.token
          //   }
          // })
          
          this.$message({
            type: 'success',
            message: this.$t('logout.loginseccess')
          })
          
          setTimeout(() => {
            this.visible = false
            this.haslogin = true
            this.loginForm = {
              phone: '',
              password: ''
            }
          }, 1000)
        }
      } catch (error) {
        console.error('登录失败:', error)
      }
    },

    // 获取用户数据的方法
    getUserData() {
      const userStr = localStorage.getItem('user')
      if (userStr) {
        try {
          return JSON.parse(userStr) // 将存储的字符串解析回对象
        } catch (e) {
          console.error('解析用户数据失败:', e)
          return null
        }
      }
      return null
    },


    async resetPassword(){
      let res=await resetPassword(this.forgotPasswordForm)
      console.log('res',res)
      if(res.code==1){
        this.$message.success(this.$t('logout.chongzhimima'))
        this.visible=false
        this.forgotPasswordForm={
          phone: '',
          code: '',
          password: '',
          passagain: ''
        }
      }
    },

    // 清空登录表单的方法
    resetLoginForm() {
      this.loginForm = {
        phone: '',
        password: ''
      }
      if (this.$refs.loginForm) {
        this.$refs.loginForm.resetFields()
      }
    },

    async sendcode1(){
      // let res=await SendCode({phone:this.loginForm.phone})
      // console.log('res',res)
            // 先验证手机号
            const phoneReg = /^1[3-9]\d{9}$/
      if (!this.loginForm.phone) {
        this.$message.error('请输入手机号')
        return
      }
      if (!phoneReg.test(this.loginForm.phone)) {
        this.$message.error('请输入正确的手机号')
        return
      }

      try {
        // 调用送验证码接口
        const res = await SendCode({ phone: this.loginForm.phone })
        
        if (res.code === 1) { // 假设 1 是成功状态码
          // 显示成功提示
          this.$message.success('验证码发送成功')
          
          // 开始倒计时
          this.send = 2 // 禁用按钮
          this.minute = 60 // 重置倒计时时间
          
          // 创建定时器
          const timer = setInterval(() => {
            this.minute--
            if (this.minute <= 0) {
              this.send = 1 // 启用按钮
              this.minute = 60 // 重置时间
              clearInterval(timer) // 清除定时器
            }
          }, 1000)
        } else {
          this.$message.error(res.message || '验证码发送失败')
        }
      } catch (error) {
        console.error('发送验证码失败:', error)
        this.$message.error('验证码发送失败，请稍后重试')
      }
    },

    async sendcode2() {
      // 先验证手机号
      const phoneReg = /^1[3-9]\d{9}$/
      if (!this.forgotPasswordForm.phone) {
        this.$message.error('请输入手机号')
        return
      }
      if (!phoneReg.test(this.forgotPasswordForm.phone)) {
        this.$message.error('请输入正确的手机号')
        return
      }

      try {
        // 调用送验证码接口
        const res = await SendCode({ phone: this.forgotPasswordForm.phone })
        
        if (res.code === 1) { // 假设 1 是成功状态码
          // 显示成功提示
          this.$message.success('验证码发送成功')
          
          // 开始倒计时
          this.send = 2 // 禁用按钮
          this.minute = 60 // 重置倒计时时间
          
          // 创建定时器
          const timer = setInterval(() => {
            this.minute--
            if (this.minute <= 0) {
              this.send = 1 // 启用按钮
              this.minute = 60 // 重置时间
              clearInterval(timer) // 清除定时器
            }
          }, 1000)
        } else {
          this.$message.error(res.message || '验证码发送失败')
        }
      } catch (error) {
        console.error('发送验证码失败:', error)
        this.$message.error('验证码发送失败，请稍后重试')
      }
    },

    async sendUserInfo(){
      console.log('this.registerForm', this.registerForm)  
      try {
        let res = await sendUserInfo(this.registerForm)
        console.log('res', res)
        
        // 判断注册是否成功
        if (res.code === 1) { // 假设 200 是成功状态码，请根据实际接口调整
          // 显示成功提示
          this.$message({
            type: 'success',
            message: '注册成功'
          })
          
          // 重置注册表单
          this.resetForm()
          
          // 切换到登录界面
          setTimeout(() => {
            this.reg = false
            this.isLogin = true
            this.isDynamicLogin = false
          }, 1000) // 延迟1秒切换，让用户能看到成功提示
        } else {
          // 注册失败的提示
          
        }
      } catch (error) {
        // 理请求错误
        
        // console.error('注册失败:', error)
      }
    },


    Forgotpassword(){
      this.visible=true
      this.isLogin=false
      this.reg=false
      this.Forgot=true
    },
    register(){
      this.Forgot = false
      this.visible = true
      this.reg = true
      this.isLogin = false
      this.resetForm()
    },
    resetForm() {
      this.registerForm = {
        username: '',
        phone: '',
        code: '',
        password: '',
        passagain: '',
        // avaimg:'../assets/img/avatar.png'
      }
      if (this.$refs.registerForm) {
        this.$refs.registerForm.resetFields()
      }
    },
    async sendcode(){
      // 先验证手机号
      const phoneReg = /^1[3-9]\d{9}$/
      if (!this.registerForm.phone) {
        this.$message.error('请输入手机号')
        return
      }
      if (!phoneReg.test(this.registerForm.phone)) {
        this.$message.error('请输入正确的手机号')
        return
      }
      let res=await SendCode({phone:this.registerForm.phone})
      console.log('res',res)

      // 手机号验证通过后再发送验证码
      this.send = 2
      this.minute = 60
      let timer = setInterval(() => {
        this.minute--
        if (this.minute < 60) {
          this.minute = this.minute
        }
        if (this.minute == 0) {
          this.send = 1
          clearInterval(timer)
        }
      }, 1000)
    },
    fastlogin(a){
      console.log(a)
      if(a==4){
        this.isDynamicLogin=true
      }
      if(a==2){
        this.isDynamicLogin=false
      }
    },
    Login() {
      console.log('Header 组件的 Login 方法被调用');
      this.Forgot=false
      this.visible = true
      this.isLogin = true
      this.reg=false
    },

    toggleLanguage() {
      const newLang = this.$i18n.locale === 'zh' ? 'en' : 'zh';
      this.$i18n.locale = newLang;
      localStorage.setItem('userLanguage', newLang); // 保存用户选择的语言
      console.log('切换语言成功:', localStorage.getItem('userLanguage'))
    },
    handleSearch() {
      if (this.searchKeyword.trim()) {
        // 存储搜索关键词
        localStorage.setItem('searchKeyword', this.searchKeyword)
        
        // 如果当前在搜索页面
        if (this.$route.path.includes('/search')) {
          // 触发一个自定义事件，让搜索页面知道需要更新
          this.$root.$emit('search-keyword-changed', this.searchKeyword)
        } else {
          // 如果不在搜索页面，则导航到搜索页面
          const targetPath = `/search/${this.searchKeyword}`
          this.$router.push({ path: targetPath })
        }
      }
    },
    handleScroll() {
      // 获取滚动距离
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      // 设置渐变的阈值（比如在200px的滚动距离内完成渐变）
      const threshold = 200
      // 更新滚动状态
      this.isScrolled = scrollTop > threshold
    },
    handleNavClick(type) {
      // 可以在这里添加点击导航的处理逻辑
      console.log('导航点击:', type)
    },
    scrollToSection(sectionId) {
      // 确保当前页面
      if (this.$route.path === '/group') {
        console.log('sectionId',sectionId)
        const element = document.getElementById(sectionId)
        setTimeout(() => {
          if (element) {
            element.scrollIntoView({  block: 'center', behavior: 'smooth' })
            
          }
        }, 300)
      } 
    },
    isActive(path) {
      // 如果是首页路径，只有当前路由完全匹配 '/' 时才返回 true
      if (path === '/') {
        return this.$route.path === '/'
      }
      // 对于其他路径，检查当前路由是否以该路径开头
      return this.$route.path.startsWith(path)
    },
    // 添加登出方法
    logout() {
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      this.haslogin = false
      // 可能需要跳转到首页或其他操作
      this.$router.push('/')
    },
    // 跳转到人中心
    goToUserCenter() {
      this.$router.push('/user')
    },

    // 退出登录
    // logout() {
    //   this.visible = false
    //   this.haslogin = false
    //   // 清除本地存储
    //   localStorage.removeItem('token')
    //   localStorage.removeItem('userInfo')
    // },

    // 处理退出登录
    handleLogout() {
      this.$confirm(this.$t('logout.confirm'), this.$t('logout.tip'), {
        confirmButtonText: this.$t('logout.confirmBtn'),
        cancelButtonText: this.$t('logout.cancelBtn'),
        type: 'warning'
      }).then(() => {
        localStorage.removeItem('token')
        localStorage.removeItem('user')
        this.haslogin = false
        this.$message.success(this.$t('logout.success'))
        // 如果当前在个人中心页面，则跳转到首页
        if (this.$route.path === '/user') {
          this.$router.push('/')
        }
      }).catch(() => {})
    },
      

    // 检查登录状态
    checkLoginStatus() {
      const token = localStorage.getItem('token')
      this.haslogin = !!token
    }
  },
  watch: {
    visible(newVal) {
      if (!newVal) {
        // 弹窗关闭时清空所有表单
        this.resetLoginForm()
        this.resetForm()
      }
    },
    $route: {
      immediate: true,
      handler(to) {
        // 检查登录状态
        this.checkLoginStatus()
        
        // 判断是否显示轮播图样式
        const routesWithCarousel = [
          '/', // 首页
          // '/home',
          '/group', // 集团概括
          '/talent', // 人才服务
          '/enterprise/lifecycle', // 企业服务
          '/government/service', // 政府服务
        ]
        
        // 更新轮播图状态
        this.hasCarousel = routesWithCarousel.includes(to.path)
      }
    }
  },
  computed: {
    isHomePage() {
      return this.$route.path === '/'
    }
  }
}
</script>

<style scoped>
.el-dialog{
  z-index: 2007 !important;
}
.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 80px;
  z-index: 100;
  transition: all 0.3s ease;
  /* 默认样式（无轮播图页面） */
  background: #FFFFFF;
  box-shadow: 0px 4px 8px 0px rgba(113,113,113,0.1);
}

/* 有轮播图页面的样式 */
.header-with-carousel {
  background: transparent;
  box-shadow: none;
}

/* 有轮播图页面滚动时的样式 */
.header-with-carousel.header-scroll {
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0px 4px 8px 0px rgba(113,113,113,0.1);
}

/* 导航链接样式 */
.nav__link {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #333333 !important;
  line-height: 20px;
  font-style: normal;
  text-decoration: none;
  cursor: pointer;
  position: relative;
  padding: 30px 0;
}

/* 无轮播图页面的选中和悬停样式 */
.nav__link:hover,
.router-link-active {
  color: #3379F2 !important;
  font-weight: 600;
}

/* 无轮播图页面的下划线样式 */
.nav__link:hover::after,
.router-link-exact-active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 28px;
  height: 2px;
  background-color: #3379F2;
  transform: translateX(-50%);
}

/* 有轮播图页面的导航链接样式 */
.header-with-carousel .nav__link {
  color: #FFFFFF !important;
}

/* 有轮播图页面的选中和悬停样式 */
.header-with-carousel .nav__link:hover,
.header-with-carousel .router-link-active {
  color: #FFFFFF !important;
  font-weight: 600;
}

/* 有轮播图页面的下划线样式 */
.header-with-carousel .nav__link:hover::after,
.header-with-carousel .router-link-exact-active::after {
  background-color: #FFFFFF;
}

/* 有轮播图页面滚动后的样式 */
.header-with-carousel.header-scroll .nav__link {
  color: #333333 !important;

}

.header-with-carousel.header-scroll .nav__link:hover,
.header-with-carousel.header-scroll .router-link-active {
  color: #3379F2 !important;
}

.header-with-carousel.header-scroll .nav__link:hover::after,
.header-with-carousel.header-scroll .router-link-exact-active::after {
  background-color: #3379F2;
}

/* 下拉菜单样式保持不变 */
.dropdown-menu a {
  color: #333333 !important;
}

.dropdown-menu a:hover {
  color: #3379F2 !important;
  font-weight: 600 !important;
}

.header__container {
  max-width: 1220px;
  margin: 0 auto;
  padding: 0 20px;
  height: 80px;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
}

.header__nav {
  flex-shrink: 0;
}

/* 右侧部分 */
.header__right {
  margin-left: 16px;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  flex-shrink: 0;
  white-space: nowrap;
  gap: 4px;
}

.search-box {
  position: relative;
  width: 130px;
  flex-shrink: 0;
}

.search-box input {
  padding: 8px 12px;
  background: #FFFFFF;
  border-radius: 15px;
  border: 1px solid #E0E0E0;
  width: 130px;
  height: 30px;
  font-size: 14px;
  font-family: PingFangSC, PingFang SC;
  outline: none;
  flex-shrink: 0;
  box-sizing: border-box;
}

.header__logo {
  margin-right: 15px;
  flex-shrink: 0;
}

.header__logo img {
  height: 40px;
}

.nav__list {
  display: flex;
  flex-wrap: nowrap;
  list-style: none;
  margin: 0;
  padding: 0;
}

.nav__item {
  position: relative;
  margin: 0 15px;
  height: 80px;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.nav__link {
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 14px;
  color: #484848 !important;
  line-height: 20px;
  font-style: normal;
  text-decoration: none;
  cursor: pointer;
  position: relative;
  padding: 30px 0;
  white-space: nowrap;
}

.nav__link:hover,
.router-link-active {
  color: #3379F2 !important;
  font-weight: 600;
}

/* 修改下划线果位置 */
.nav__link:hover::after,
.router-link-exact-active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 28px;
  height: 2px;
  background-color: #3379F2;
  transform: translateX(-50%);
}

/* 下拉菜单样式也需要更新 */
.dropdown-menu {
  display: none;
  position: absolute;
  top: 80px;
  left: 50%;
  transform: translateX(-50%);
  background: #FFFFFF;
  box-shadow: 0px 4px 8px 0px rgba(113,113,113,0.1);
  border-radius: 10px;
  opacity: 0.98;
  width: 160px;
  padding: 12px 0;
  margin-top: 0;
  z-index: 1000;
}

/* 下拉菜单项样式 */
.nav__link1 {
  display: block;
  padding: 12px 16px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #484848 !important;
  line-height: 20px;
  font-style: normal;
  text-decoration: none;
  text-align: center;
}

/* 覆盖下拉菜单中的 router-link-active 样式 */
.dropdown-menu .router-link-active,
.dropdown-menu .router-link-exact-active {
  color: #484848 !important;
  font-weight: 400 !important;
}

/* 只在悬停时改变样式 */
/* .nav__link1:hover {
  color: #3379F2 !important;
  font-weight: 400 !important;
} */

/* 移除下拉菜单项的下划线 */
.nav__link1::after,
.dropdown-menu .router-link-active::after,
.dropdown-menu .router-link-exact-active::after {
  display: none !important;
}

/* 确保下拉菜单项不继承父级的激活样式 */
.has-dropdown.router-link-active .nav__link1 {
  color: #484848 !important;
  font-weight: 400;
}

.dropdown-menu li {
  list-style: none;
  position: relative;
}

.dropdown-menu li:not(:last-child)::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: calc(100% - 24px);
  height: 1px;
  background-color: #F0F0F0;
}

.dropdown-menu a {
  display: block;
  padding: 12px 16px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #484848;
  line-height: 20px;
  font-style: normal;
  text-decoration: none;
  text-align: center;
}

.nav__link1{
   display: block;
  padding: 12px 16px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #484848;
  line-height: 20px;
  font-style: normal;
  text-decoration: none;
  text-align: center;
}

.dropdown-menu a:hover {
  color: #3379F2;
  font-weight: 600;
}

.has-dropdown:hover .dropdown-menu {
  display: block;
}

/* 搜索按钮样式也需要调整以配合新的搜索框样式 */
.search-box input:focus {
  border-color: #3379F2; /* 聚焦时的边框颜色 */
}

.search-btn {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  color: #999;
}

.auth-buttons {
  margin: 0 8px;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  flex-shrink: 0;
  white-space: nowrap;
}

.auth-btn {
  font-family: PingFangSC, PingFang SC;
  font-weight: 600;
  font-size: 14px;
  text-decoration: none;
  margin: 0 4px;
  font-style: normal;
  cursor: pointer;
  color: #333333;
  white-space: nowrap;
  flex-shrink: 0;
}

/* 有轮播图时的样式 */
.header-with-carousel .auth-btn {
  color: #FFFFFF;
}

/* 滚动后的样式 */
.header-with-carousel.header-scroll .auth-btn {
  color: #333333;
}

/* 分隔符样式 */
.auth-buttons span {
  color: #333333;
  margin: 0 5px;
}

.header-with-carousel .auth-buttons span {
  color: #FFFFFF;
}

.header-with-carousel.header-scroll .auth-buttons span {
  color: #333333;
}

/* 鼠标悬停效果 */
.auth-btn:hover {
  color: #3379F2 !important;
}

/* 搜索框样式优化 */
.search-box input {
  background: #F5F5F5;
  border: none;
}

.header-with-carousel .search-box input {
  background: rgba(255, 255, 255, 0.2);
  color: #FFFFFF;
  width: 130px;
}

.header-with-carousel.header-scroll .search-box input {
  background: #F5F5F5;
  color: #333333;
}

.lang-switch {
  padding: 7px 10px;
  border: 1px solid #3379F2;
  border-radius: 15px;
  background: none;
  color: #3379F2;
  cursor: pointer;
  font-family: PingFangSC, PingFang SC;
  font-size: 12px;
  flex-shrink: 0;
  white-space: nowrap;
}

.lang-switch:hover {
  background: #3379F2;
  color: #fff;
}

/* 中文模式：略微压缩间距，避免右侧登录/注册区域换行 */
.header--zh .nav__item {
  margin: 0 10px;
}

.header--zh .search-box,
.header--zh .search-box input {
  width: 118px;
}

.header--zh .auth-buttons {
  margin: 0 4px;
}

.header--zh .auth-btn {
  margin: 0 2px;
  font-size: 13px;
}

.header--zh .lang-switch {
  padding: 6px 8px;
  font-size: 11px;
}

.header--zh.header-with-carousel .search-box input {
  width: 118px;
}

@media screen and (max-width: 1200px) {
  .search-box input {
    width: 130px;
  }

  .header--zh .search-box,
  .header--zh .search-box input {
    width: 118px;
  }
}

@media screen and (max-width: 1320px) {
  .nav__link {
    font-size: 13px;
  }

  .nav__item {
    margin: 0 10px;
  }

  .header__logo img {
    height: 60px;
  }
}

@media screen and (min-width: 1321px) {
  .header__logo img {
    height: 60px;
  }

  .header__container {
    max-width: 1320px;
  }
}

@media screen and (max-width: 1190px) {
  .nav__link {
    font-size: 12px;
  }
}

@media screen and (max-width: 992px) {
  .header__nav {
    display: none;
  }
  
  .search-box {
    display: none;
  }
  
  .auth-buttons {
    display: none;
  }






}

/* 添加激活链接的样式 */
.active-link {
  /* color: #3379F2 !important; */
  font-weight: 600;
}

.active-link::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  width: 28px;
  height: 2px;
  /* background-color: #3379F2; */
  transform: translateX(-50%);
}

/* 有轮播图时的激活样式 */
.header-with-carousel .active-link {
  color: #FFFFFF !important;
}

.header-with-carousel .active-link::after {
  background-color: #FFFFFF;
}

/* 滚动后的激活样式 */
.header-with-carousel.header-scroll .active-link {
  color: #3379F2 !important;
}

.header-with-carousel.header-scroll .active-link::after {
  background-color: #3379F2;
}

/* 下拉菜单项基础样式 */
.dropdown-menu .nav__link1 {
  display: block;
  padding: 12px 16px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400 !important;
  font-size: 14px;
  color: #484848 !important;
  line-height: 20px;
  font-style: normal;
  text-decoration: none;
  text-align: center;
  transition: all 0.3s ease;
}

/* 下拉菜单项悬停样式 - 提高优先级 */
.dropdown-menu li .nav__link1:hover {
  color: #3379F2 !important;
  font-weight: 600 !important;
}

/* 确保激活状态不影响悬停效果 */
.dropdown-menu li .nav__link1.router-link-active:hover,
.dropdown-menu li .nav__link1.router-link-exact-active:hover {
  color: #3379F2 !important;
  font-weight: 600 !important;
}

/* 重置激活状态样式 */
.dropdown-menu li .nav__link1.router-link-active,
.dropdown-menu li .nav__link1.router-link-exact-active {
  color: #484848 !important;
  font-weight: 400 !important;
}

/* 移除下划线 */
.dropdown-menu .nav__link1::after,
.dropdown-menu .nav__link1:hover::after,
.dropdown-menu .nav__link1.router-link-active::after {
  display: none !important;
}

/* 确保父级激活状态不影响子菜单 */
.has-dropdown.router-link-active .dropdown-menu .nav__link1 {
  color: #484848 !important;
  font-weight: 400 !important;
}
</style> 